import $ from 'jquery' /*引入jquery*/
import util from './util.js' /*引入 公共工具 模块*/
	

export default function(getModelDom){
	/*1级文字链点击事件*/
    $('.nav-model').on('click', '.nav-item', navItemClk)
}

function navItemClk(){
    if($(this).hasClass('cur')){
        return
    }else{
        $(this).addClass('cur').siblings().removeClass('cur')
        $('.subModelList').siblings().hide()
        $('.subModelList').eq($(this).index()).show()
        $('.rightContainer').scrollTop(0)
    }
}